{
  "familyId": "GET-VERH-RECEPT",
  "questions": [
    {
      "id": "GET-VERH-RECEPT-001",
      "familyId": "GET-VERH-RECEPT",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_recept",
      "questionType": "multiple_choice",
      "question": "Een recept voor 4 personen vraagt 200 gram bloem. Hoeveel gram bloem heb je nodig voor 6 personen?",
      "options": ["300 gram", "250 gram", "400 gram", "1200 gram"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Personen", "Bloem (gram)"],
            "rows": [[4, 200], [6, "?"]],
            "label": "Verhoudingstabel: recept opschalen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Personen", "Bloem (gram)"],
            "rows": [[1, 50], [4, 200], [6, 300]],
            "label": "Per persoon: 200 ÷ 4 = 50 gram. Voor 6 personen: 50 × 6 = 300 gram"
          }
        }
      ],
      "conceptId": "verh_recept_opschalen",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Strategie: bereken eerst de hoeveelheid per persoon. Stap 1: Per persoon: 200 ÷ 4 = 50 gram. Stap 2: Voor 6 personen: 50 × 6 = 300 gram.",
        "solutionSteps": [
          "Per persoon: 200 ÷ 4 = 50 gram",
          "Voor 6 personen: 50 × 6 = 300 gram"
        ],
        "distractorExplanations": {
          "0": "Goed! 200 ÷ 4 = 50 gram per persoon. 50 × 6 = 300 gram.",
          "1": "Veelgemaakte fout: 200 + 50 = 250. Je moet vermenigvuldigen: 50 × 6 = 300.",
          "2": "Veelgemaakte fout: verdubbelen. 200 × 2 = 400, maar 6 personen is 1,5× zoveel als 4, niet 2×.",
          "3": "Veelgemaakte fout: 200 × 6 = 1200. Je moet eerst per persoon berekenen: 200 ÷ 4 = 50."
        }
      }
    },
    {
      "id": "GET-VERH-RECEPT-002",
      "familyId": "GET-VERH-RECEPT",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_recept",
      "questionType": "multiple_choice",
      "question": "Voor 8 pannenkoeken heb je 3 eieren nodig. Hoeveel eieren heb je nodig voor 24 pannenkoeken?",
      "options": ["9", "6", "12", "72"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Pannenkoeken", "Eieren"],
            "rows": [[8, 3], [24, "?"]],
            "label": "Verhoudingstabel: pannenkoeken"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Pannenkoeken", "Eieren"],
            "rows": [[8, 3], [16, 6], [24, 9]],
            "label": "Factor: 24 ÷ 8 = 3. Eieren: 3 × 3 = 9"
          }
        }
      ],
      "conceptId": "verh_recept_factor",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Strategie: bepaal de vermenigvuldigingsfactor. Stap 1: Factor: 24 ÷ 8 = 3. Stap 2: Eieren: 3 × 3 = 9.",
        "solutionSteps": [
          "Factor: 24 ÷ 8 = 3",
          "Eieren: 3 × 3 = 9"
        ],
        "distractorExplanations": {
          "0": "Goed! 24 is 3× zoveel als 8, dus 3 × 3 = 9 eieren.",
          "1": "Veelgemaakte fout: factor 2 gebruiken. 24 ÷ 8 = 3 (niet 2). 3 × 3 = 9.",
          "2": "Veelgemaakte fout: factor 4 gebruiken. 24 ÷ 8 = 3, niet 4. 3 × 3 = 9.",
          "3": "Veelgemaakte fout: 3 × 24 = 72. Je vermenigvuldigt de eieren met de factor, niet met het totaal."
        }
      }
    },
    {
      "id": "GET-VERH-RECEPT-003",
      "familyId": "GET-VERH-RECEPT",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_recept",
      "questionType": "multiple_choice",
      "question": "Een smoothie voor 2 personen: 300 ml melk en 150 gram fruit. Hoeveel melk voor 5 personen?",
      "options": ["750 ml", "600 ml", "500 ml", "1500 ml"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Personen", "Melk (ml)"],
            "rows": [[2, 300], [5, "?"]],
            "label": "Verhoudingstabel: smoothie"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Personen", "Melk (ml)"],
            "rows": [[1, 150], [2, 300], [5, 750]],
            "label": "Per persoon: 300 ÷ 2 = 150 ml. Voor 5 personen: 150 × 5 = 750 ml"
          }
        }
      ],
      "conceptId": "verh_recept_halve_factor",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: bereken per persoon, dan vermenigvuldigen. Stap 1: Per persoon: 300 ÷ 2 = 150 ml. Stap 2: Voor 5 personen: 150 × 5 = 750 ml.",
        "solutionSteps": [
          "Per persoon: 300 ÷ 2 = 150 ml",
          "Voor 5 personen: 150 × 5 = 750 ml"
        ],
        "distractorExplanations": {
          "0": "Goed! 300 ÷ 2 = 150 ml per persoon. 150 × 5 = 750 ml.",
          "1": "Veelgemaakte fout: verdubbelen. 300 × 2 = 600, maar je hebt 5 personen, niet 4.",
          "2": "Veelgemaakte fout: 100 ml per persoon rekenen. 300 ÷ 2 = 150 (niet 100). 150 × 5 = 750.",
          "3": "Veelgemaakte fout: 300 × 5 = 1500. Je moet eerst per persoon berekenen: 300 ÷ 2 = 150."
        }
      }
    },
    {
      "id": "GET-VERH-RECEPT-004",
      "familyId": "GET-VERH-RECEPT",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_recept",
      "questionType": "multiple_choice",
      "question": "Een recept voor 10 koekjes vraagt 250 gram suiker. Je wilt 4 koekjes bakken. Hoeveel gram suiker heb je nodig?",
      "options": ["100 gram", "125 gram", "25 gram", "1000 gram"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Koekjes", "Suiker (gram)"],
            "rows": [[10, 250], [4, "?"]],
            "label": "Verhoudingstabel: koekjes afschalen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Koekjes", "Suiker (gram)"],
            "rows": [[1, 25], [4, 100], [10, 250]],
            "label": "Per koekje: 250 ÷ 10 = 25 gram. Voor 4 koekjes: 25 × 4 = 100 gram"
          }
        }
      ],
      "conceptId": "verh_recept_afschalen",
      "variantIndex": 4,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: bereken per koekje, dan vermenigvuldigen. Stap 1: Per koekje: 250 ÷ 10 = 25 gram. Stap 2: Voor 4 koekjes: 25 × 4 = 100 gram.",
        "solutionSteps": [
          "Per koekje: 250 ÷ 10 = 25 gram",
          "Voor 4 koekjes: 25 × 4 = 100 gram"
        ],
        "distractorExplanations": {
          "0": "Goed! 250 ÷ 10 = 25 gram per koekje. 25 × 4 = 100 gram.",
          "1": "Veelgemaakte fout: halveren. 250 ÷ 2 = 125, maar 4 koekjes is niet de helft van 10.",
          "2": "Veelgemaakte fout: alleen per koekje berekenen. 25 gram is voor 1 koekje, maar je wilt er 4.",
          "3": "Veelgemaakte fout: 250 × 4 = 1000. Je moet eerst per koekje berekenen: 250 ÷ 10 = 25."
        }
      }
    },
    {
      "id": "GET-VERH-RECEPT-005",
      "familyId": "GET-VERH-RECEPT",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_recept",
      "questionType": "multiple_choice",
      "question": "In een recept is de verhouding bloem : suiker = 3 : 1. Je gebruikt 450 gram bloem. Hoeveel gram suiker heb je nodig?",
      "options": ["150 gram", "450 gram", "1350 gram", "50 gram"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Bloem (gram)", "Suiker (gram)"],
            "rows": [[3, 1], [450, "?"]],
            "label": "Verhouding bloem : suiker = 3 : 1"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Bloem (gram)", "Suiker (gram)"],
            "rows": [[3, 1], [150, 50], [450, 150]],
            "label": "1 deel = 450 ÷ 3 = 150 gram. Suiker = 1 deel = 150 gram"
          }
        }
      ],
      "conceptId": "verh_recept_verhouding",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: gebruik de verhouding om de factor te bepalen. Stap 1: Verhouding 3 : 1 → bloem is 3 delen. Stap 2: 1 deel = 450 ÷ 3 = 150 gram. Stap 3: Suiker = 1 deel = 150 gram.",
        "solutionSteps": [
          "Verhouding 3:1 → bloem is 3 delen",
          "1 deel = 450 ÷ 3 = 150 gram",
          "Suiker = 1 deel = 150 gram"
        ],
        "distractorExplanations": {
          "0": "Goed! 450 ÷ 3 = 150 gram suiker. De verhouding 3:1 betekent 3× zoveel bloem als suiker.",
          "1": "Veelgemaakte fout: evenveel suiker als bloem. De verhouding is 3:1, niet 1:1.",
          "2": "Veelgemaakte fout: 450 × 3 = 1350. Je deelt door 3, niet vermenigvuldigen.",
          "3": "Veelgemaakte fout: door de totale verhouding delen. 450 ÷ (3+1) = 112,5 ≠ 50. Suiker = 450 ÷ 3 = 150."
        }
      }
    }
  ]
}
